module.exports = __webpack_public_path__ + "img/ios-flower.396e6d67.svg";